export default __webpack_public_path__ + "static/media/Lock.46b08009.svg";